import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * ProductGallery Component
 * Props:
 * - images array
 * - mainImageIndex (default 0)
 * Features:
 * - Main image left, thumbnails below
 * - Thumbnail click changes main image
 * - Optional zoom on hover
 * - Animations: fade-in switching main image
 */

const ProductGallery = ({ images = [], mainImageIndex = 0 }) => {
  const [selectedIndex, setSelectedIndex] = useState(mainImageIndex);

  return (
    <div className="space-y-4">
      {/* Main Image */}
      <div className="relative w-full h-96 md:h-[500px] bg-gray-100 rounded-lg overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.img
            key={selectedIndex}
            src={images[selectedIndex]}
            alt={`Product view ${selectedIndex + 1}`}
            className="w-full h-full object-contain"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          />
        </AnimatePresence>
      </div>

      {/* Thumbnails */}
      <div className="flex space-x-2 overflow-x-auto pb-2">
        {images.map((image, index) => (
          <button
            key={index}
            onClick={() => setSelectedIndex(index)}
            className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all duration-300 ${
              selectedIndex === index
                ? 'border-secondary-500 shadow-lg'
                : 'border-gray-200 hover:border-gray-400'
            }`}
          >
            <img
              src={image}
              alt={`Thumbnail ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProductGallery;

